import React from "react";
import singleQRCode from "../../images/mgdm-prod.png";

const AppStoreQR = () => {
  const handleQRClick = (e) => {
    e.preventDefault();

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const androidUrl =
      "https://play.google.com/store/apps/details?id=com.ri.MGDM.mgdm";

    const iosUrl =
      "https://apps.apple.com/ca/app/mgdm-product-app/id1573541003";

    if (/android/i.test(userAgent)) {
      window.location.href = androidUrl;
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href = iosUrl;
    } else {
      // Desktop fallback – optional
      window.open(androidUrl, "_blank");
    }
  };

  return (
    <div className="col-6 col-lg-3 col-md-4">
      <h5 className="uppercase font-bold tracking-widest m-0">
        Download Our App
      </h5>

      {/* QR Image */}
      <a href="https://mgdm.in" onClick={handleQRClick}>
        <img
          src={singleQRCode}
          className="w-100"
          alt="Download app QR code"
          style={{ cursor: "pointer" }}
        />
      </a>

      <div className="mt-2 small text-muted">
        Scan / Click to download on Android or iOS
      </div>
    </div>
  );
};

export default AppStoreQR;
